import React from 'react';
import './assets/sass/style.scss';
import App from './App';

import { createRoot } from "react-dom/client";
const rootElement = document.getElementById("root");
const root = createRoot(rootElement);
root.render(<App />);
